import React from 'react';
import { FiAlertCircle, FiAlertTriangle, FiCheckCircle, FiInfo } from 'react-icons/fi';

const ICONS = {
  info: <FiInfo aria-hidden="true" />,
  warning: <FiAlertTriangle aria-hidden="true" />,
  error: <FiAlertCircle aria-hidden="true" />,
  success: <FiCheckCircle aria-hidden="true" />,
};

const Notice = ({ variant = 'compliance', children, role, className = '' }) => {
  if (variant === 'compliance' || variant === 'inline') {
    return (
      <div className={`cy-notice cy-notice--${variant} ${className}`}>{children}</div>
    );
  }
  return (
    <div className={`cy-notice cy-notice--${variant} ${className}`} role={role}>
      <span className="cy-notice__icon" aria-hidden="true" style={{ fontSize: 20, flexShrink: 0 }}>
        {ICONS[variant]}
      </span>
      <div className="cy-notice__body">{children}</div>
    </div>
  );
};

export default Notice;
